<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@import "../static/css/global.css";

</style>
<style>
/* 新增按钮 */
.addIcon{
  font-size: 24px;
  color: #b8bac0;
  cursor: pointer;
}
/* 表格操作栏样式 */
.operation{
  display: flex;

}
/* 输入框聚焦 */
.el-select .el-input.is-focus .el-input__inner,.el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #091d7c ;
}

</style>



// WEBPACK FOOTER //
// src/App.vue